import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';

import css from './ListingPage.module.css';

/**
 * Shows who pays for shipping when delivery is enabled for a listing.
 *
 * @component
 * @param {Object} props
 * @param {Object} props.publicData - Listing public data
 * @returns {JSX.Element|null}
 */
const ShippingPayerInfo = props => {
  const { publicData } = props;

  if (!publicData?.shippingEnabled) {
    return null;
  }

  const isFreeShipping = publicData.shippingPayer === 'seller';

  return (
    <p className={css.shippingPayerInfo}>
      <FormattedMessage
        id={
          isFreeShipping
            ? 'ListingPage.freeShipping'
            : 'ListingPage.buyerPaysForShipping'
        }
      />
    </p>
  );
};

export default ShippingPayerInfo;
